import 'regenerator-runtime/runtime'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './utils/request'
import './assets/styles/theme.css'
import './assets/styles/components.css'
// 设计系统 token 需最后引入，以确保对上面主题变量的覆盖生效
import './assets/styles/tokens.css'

// 配置Element Plus使用中文本地化
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 设置全局日期时间处理时区
window.TIME_ZONE = 'Asia/Shanghai'

// 静默处理 ResizeObserver 良性错误
if (typeof window !== 'undefined') {
    window.addEventListener('error', e => {
        if (e.message && e.message.includes('ResizeObserver')) {
            e.stopImmediatePropagation()
        }
    })

    if ('ResizeObserver' in window) {
        const Rz = window.ResizeObserver
        window.ResizeObserver = class extends Rz {
            constructor(callback) {
                super((entries, observer) => {
                    requestAnimationFrame(() => callback(entries, observer))
                })
            }
        }
    }
}

const app = createApp(App)

// Element Plus ResizeObserver 错误处理
app.config.errorHandler = (err) => {
    if (err.message && err.message.includes('ResizeObserver')) {
        return // 静默处理 ResizeObserver 相关错误
    }
    // 其他错误正常处理
    console.error('Vue 错误:', err)
}

app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.use(store)

app.mount('#app')
